<template>
  <div
    v-if="enableHistory"
    class="search-history-fi"
  >
    <search-history-slider-fi
      :history-active
      class="search-history-fi__slidein"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, ref, watchEffect } from 'vue';
import { useStore } from 'vuex';

import { useBreakpoints } from '@/composables/breakpoint';

const SearchHistorySliderFi = defineAsyncComponent(() => import('./SearchHistorySliderFi.vue'));

defineOptions({
  name: 'SearchHistoryFi',
});

const props = defineProps<{
  lg?: boolean;
}>();

const store = useStore();
const { isLG } = useBreakpoints();

const enableHistory = ref(false);
const historyActive = ref(false);

const query = computed<string>(() => store.getters['search/getQueryTrimmed']);

watchEffect(() => {
  if (IS_SSR) {
    return;
  }
  if (props.lg) {
    if (!isLG.value) {
      enableHistory.value = false;
      return;
    }
  } else {
    if (isLG.value) {
      enableHistory.value = false;
      return;
    }
  }
  if (query.value.length > 0) {
    historyActive.value = false;
    return;
  }
  if (
    store.getters['navigation/searchFocused'] ||
    (!isLG.value && store.getters['navigation/searchActive'])
  ) {
    enableHistory.value = true;
    historyActive.value = true;
    return;
  }
  if (historyActive.value) {
    // use timeout to let click handlers finish
    setTimeout(() => {
      historyActive.value = false;
    }, 150);
  }
});

const close = () => (historyActive.value = false);

defineExpose({
  close,
});
</script>

<style scoped src="./search-history-fi" />
